export default "__VITE_ASSET__C9BJey4___"